import { getVersionType } from '@/utils/checkStatus'

export default [
  {
    path: '/workBench/myWorkBench',
    name: 'WorkBench',
    component: () =>
      getVersionType() === 'pro'
        ? import('@/views/application/workBenchPro.vue')
        : import('@/views/application/workBench.vue'),
    meta: {
      title: '我的工作台',
      permission: {
        old: [],
        new: []
      }
    }
  }
]
